import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    opsUrl: '',
    pages: [],
    singlePagesNoAds: [],
    sections: [],
    articles: [],
    currentPage: undefined,
    currentSection: undefined,
    currentArticle: undefined,
    showScrubber: false,
    showIssueOverview: false,
    printAndDownload: false,
    showArticleModal: false,
    showSharing: false,
    showImageGalleryModal: false,
    showImageGalleryInArticle: false,
    showOverlay: false,
    showCrop: false,
    pageSide: 0,
    pageFromSection: undefined,
    homeUrl: undefined,
    startPage: '1',
    startArticleId: undefined,
    maxZoom: 3,
    articleFontsize: 12,
    articleFontSizeUnit: 'pt',
    settings: undefined,
    isScrolling: false,
    isZoomAnimating: false,
    publicationName: '',
    interstitialsFrequency: 3,
    interstitials: [],
    resetInterstitials: false,
    token: undefined,
    entitlements: [],
    publicationId: undefined,
    adsEnabled: true,
    // sportsExtraMenuSelected: false,
    initPageLoaded: false,
    pageViewMode: undefined,
    pubDateDate: '',
    zoneCont: '',
    editionCont: '',
    issueName: '',
    issueInternalName: '',
    issueInternalId: '',
    errorMessage: ''
  },
  mutations: {
    setOpsUrl (state, opsUrl) {
      state.opsUrl = opsUrl
    },
    setPages (state, pages) {
      state.pages = pages
    },
    setSinglePagesNoAds (state, pages) {
      var noAdsArr = []
      for (var i = 0; i < pages.length; i++) {
        if (pages[i].interstitialAdAfterPage === undefined) {
          noAdsArr.push(pages[i])
        }
      }
      state.singlePagesNoAds = noAdsArr
    },
    setSections (state, sections) {
      state.sections = sections
    },
    setArticles (state, articles) {
      state.articles = articles
    },
    setCurrentPage (state, page) {
      for (var i = 0; i < state.pages.length; i++) {
        if (state.pages[i] === page) {
          state.currentPage = page
        } else if (state.pages[i].firstPage === page || state.pages[i].secondPage === page) {
          state.currentPage = state.pages[i]
        }
      }
    },
    setCurrentPageFromId (state, pageId) {
      for (var i = 0; i < state.pages.length; i++) {
        if (state.pages[i].firstPage.id === pageId || (state.pages[i].secondPage !== null && state.pages[i].secondPage.id === pageId)) {
          state.currentPage = state.pages[i]
          return
        }
      }
    },
    setCurrentSection (state, section) {
      state.currentSection = section
    },
    setCurrentArticle (state, article) {
      state.currentArticle = article
    },
    setCurrentArticleFromIds (state, ids) {
      var articleId = ids.articleId
      var pageId = ids.pageId

      // This code is only related to "jumpToArticleId" code. Which is not active for MCC.
      // for (var j = 0; j < state.articles.length; j++) {
      //   var article = state.articles[j]
      //   if (pageId !== undefined) {
      //     if (article.json.attributes.JumpOriginArticleId !== undefined && article.id === articleId && article.json.attributes.JumpOriginPageId !== undefined && article.page.id === pageId) {
      //       console.log('jumpski!')
      //       pageId = article.json.attributes.JumpOriginPageId
      //       articleId = state.articles[j].json.attributes.JumpOriginArticleId
      //     }
      //   } else {
      //     // support for issues without JumpOriginPageId.
      //     if (article.json.attributes.JumpOriginArticleId !== undefined && article.id === articleId) {
      //       console.log('the old way')
      //       articleId = state.articles[j].json.attributes.JumpOriginArticleId
      //     }
      //   }
      // }

      for (var i = 0; i < state.articles.length; i++) {
        if (pageId === undefined) {
          // support for issues without JumpOriginPageId.
          if (state.articles[i].id === articleId) {
            state.currentArticle = state.articles[i]
            return
          }
        } else {
          if (state.articles[i].id === articleId && state.articles[i].page.id === pageId) {
            state.currentArticle = state.articles[i]
            return
          }
        }
      }
    },
    setScrubberVisibile (state, showScrubber) {
      state.showScrubber = showScrubber
    },
    toggleScrubberVisible (state) {
      state.showScrubber = !state.showScrubber
    },
    setShowIssueOverview (state, showIssueOverviewObj) {
      state.showIssueOverview = showIssueOverviewObj.val
      if (showIssueOverviewObj.printAndDownload !== undefined) {
        state.printAndDownload = showIssueOverviewObj.printAndDownload
      }
    },
    setShowArticleModal (state, showArticleModal) {
      state.showArticleModal = showArticleModal
    },
    setShowSharing (state, showSharing) {
      state.showSharing = showSharing
    },
    setShowImageGalleryModal (state, show) {
      state.showImageGalleryModal = show
    },
    setShowImageGalleryInArticle (state, show) {
      state.showImageGalleryInArticle = show
    },
    setShowOverlay (state, showOverlay) {
      state.showOverlay = showOverlay
    },
    toggleCropVisible (state, pageSide) {
      state.showCrop = !state.showCrop
      state.pageSide = pageSide
    },
    changePageFromSectionsBar (state, page) {
      state.pageFromSection = undefined
      state.pageFromSection = page
    },
    setHomeUrl (state, homeUrl) {
      state.homeUrl = homeUrl
    },
    // setZoomLevelButton (state, zoomIn) {
    //   state.zoomLevelButton = zoomIn
    //   // if (zoomIn > state.maxZoom) {
    //   //   state.zoomLevelButton = state.maxZoom
    //   //   return
    //   // }
    //   // var newZoomLevel = state.zoomLevel
    //   // if (zoomIn) {
    //   //   newZoomLevel += 0.50
    //   // } else {
    //   //   newZoomLevel -= 0.50
    //   // }
    //   // if (state.zoomLevelButton < 1.0) {
    //   //   state.zoomLevelButton = 1.0
    //   // } else if (state.zoomLevelButton > state.maxZoom) {
    //   //   state.zoomLevelButton = state.maxZoom
    //   // } else {
    //   //   state.zoomLevelButton = newZoomLevel
    //   // }
    // },
    // setZoomScale (state, scale) {
    //   state.zoomLevel = scale
    // },
    setMaxZoom (state, zoom) {
      state.maxZoom = zoom
    },
    setFontSize (state, increment) {
      if (increment) {
        state.articleFontsize += 1
        Vue.cciEventTrackingPlugin.trackEvent('ContextArticleView', 'ActionArticleIncreaseFontSizeButtonClick', state.currentArticle, state.articleFontsize + state.articleFontSizeUnit, state.articleFontsize)
      } else {
        state.articleFontsize -= 1
        Vue.cciEventTrackingPlugin.trackEvent('ContextArticleView', 'ActionArticleDecreaseFontSizeButtonClick', state.currentArticle, state.articleFontsize + state.articleFontSizeUnit, state.articleFontsize)
      }
    },
    setSettings (state, settings) {
      if (settings.maxZoom) {
        state.maxZoom = parseFloat(settings.maxZoom)
      }
      state.settings = settings
    },
    setIsScrolling (state, scroll) {
      state.isScrolling = scroll
    },
    setIsZoomAnimating (state, zoom) {
      state.isZoomAnimating = zoom
    },
    setInterstitialsFrequency (state, freq) {
      state.interstitialsFrequency = freq
    },
    setInterstitials (state, interstitials) {
      state.interstitials = interstitials
    },
    setResetInterstitials (state, reset) {
      state.resetInterstitials = reset
    },
    setAdsEnabled (state, enable) {
      state.adsEnabled = enable
    },
    // setSportsExtraMenuSelected (state, selection) {
    //   state.sportsExtraMenuSelected = selection
    // },
    setInitPageLoaded (state, loaded) {
      state.initPageLoaded = loaded
    },
    setPageViewMode (state, mode) {
      state.pageViewMode = mode
    },
    togglePageViewMode (state) {
      state.pageViewMode = !state.pageViewMode
    },
    setErrorMessage (state, msg) {
      state.errorMessage = msg
    }
  },
  getters: {
    getOpsUrl: state => { return state.opsUrl },
    getPages: state => { return state.pages },
    getSinglePagesNoAds: state => { return state.singlePagesNoAds },
    getSections: state => { return state.sections },
    getArticles: state => { return state.articles },
    getCurrentPage: state => { return state.currentPage },
    getCurrentSection: state => { return state.currentSection },
    getCurrentArticle: state => { return state.currentArticle },
    getShowScrubber: state => { return state.showScrubber },
    getShowIssueOverview: state => { return state.showIssueOverview },
    getPrintAndDownload: state => { return state.printAndDownload },
    getShowArticleModal: state => { return state.showArticleModal },
    getShowImageGalleryModal: state => { return state.showImageGalleryModal },
    getShowImageGalleryInArticle: state => { return state.showImageGalleryInArticle },
    getShowSharing: state => { return state.showSharing },
    getShowOverlay: state => { return state.showOverlay },
    getShowCrop: state => { return state.showCrop },
    getPageSide: state => { return state.pageSide },
    getPageFromSection: state => { return state.pageFromSection },
    getHomeUrl: state => { return state.homeUrl },
    getStartPage: state => { return state.startPage },
    getMaxZoom: state => { return state.maxZoom },
    getArticleFontsize: state => { return state.articleFontsize },
    getSettings: state => { return state.settings },
    getIsScrolling: state => { return state.isScrolling },
    getIsZoomAnimating: state => { return state.isZoomAnimating },
    getInterstitialsFrequency: state => { return state.interstitialsFrequency },
    getInterstitials: state => { return state.interstitials },
    getResetInterstitials: state => { return state.resetInterstitials },
    getToken: state => { return state.token },
    getEntitlements: state => { return state.entitlements },
    getAdsEnabled: state => { return state.adsEnabled },
    // getSportsExtraMenuSelected: state => { return state.sportsExtraMenuSelected },
    getInitPageLoaded: state => { return state.initPageLoaded },
    getPageViewMode: state => { return state.pageViewMode },
    getErrorMessage: state => { return state.errorMessage }
  }
})
